<template>
  <main role="main" class="col content-spacing">
    <loading-list v-if="viewData.loading"></loading-list>
    <b-container v-else>
      <b-row>
        <b-col>
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
          >
            <h1 class="h2">
              {{ viewData.id ? `Editar detalhe` : 'Novo Detalhe' }}
            </h1>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="viewData.powerPlant">
        <b-col>
          <b-breadcrumb
            :items="[
              {
                text: 'Usina ' + viewData.powerPlant.name,
                href: `#/power-plant/${viewData.powerPlant.id}/data`,
              },
              {
                text: 'Cadastro Detalhe',
                href: '#',
                active: true,
              },
            ]"
          ></b-breadcrumb>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-form>
              <error-container v-bind:errors="viewData.errors || []" />

              <b-form-group
                id="input-group-1"
                label="Data inicial"
                label-for="input-1"
              >
                <b-form-datepicker
                  :state="isOk('start')"
                  placeholder="Selecione uma data"
                  v-model="state.start"
                  class="mb-2"
                ></b-form-datepicker>
                <b-form-invalid-feedback>{{
                  getError('start')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Data final"
                label-for="input-1"
              >
                <b-form-datepicker
                  :state="isOk('end')"
                  placeholder="Selecione uma data"
                  v-model="state.end"
                  class="mb-2"
                ></b-form-datepicker>
                <b-form-invalid-feedback>{{
                  getError('end')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Potência Instalada"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.powerInstalled"
                  placeholder="Informe a potência instalada"
                  :state="isOk('powerInstalled')"
                  @keypress="isNumber($event)"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('powerInstalled')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Injeção projetada"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.projectedInjection"
                  placeholder="Informe a injeção projetada"
                  :state="isOk('projectedInjection')"
                  @keypress="isNumber($event)"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('projectedInjection')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Injeção disponível"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.availableInjection"
                  placeholder="Informe a injeção projetada"
                  :state="isOk('availableInjection')"
                  @keypress="isNumber($event)"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('availableInjection')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Injeção efetiva"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.injection"
                  placeholder="Informe a injeção efetiva"
                  :state="isOk('injection')"
                  @keypress="isNumber($event)"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('injection')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Créditos"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.credits"
                  placeholder="Informe os créditos"
                  :state="isOk('credits')"
                  @keypress="isNumber($event)"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('credits')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Capex"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.capex"
                  placeholder="Informe o Capex"
                  :state="isOk('capex')"
                  @keypress="isNumber($event)"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('capex')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="input-group-1" label="Opex" label-for="input-1">
                <b-form-input
                  v-model="state.opex"
                  placeholder="Informe o Opex"
                  :state="isOk('opex')"
                  @keypress="isNumber($event)"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('opex')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <submit-button
                v-bind:action="() => save()"
                v-bind:label="'Salvar'"
              ></submit-button>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';

const API = new Api();

export default {
  name: 'power-plant-data-edit',
  data: function() {
    return {
      state: {},
      viewData: {
        id: 0,
        loading: false,
        errors: [],
        powerPlant: null,
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    const _id = this.$route.params ? this.$route.params.id : 0;

    if (_id) {
      try {
        this.viewData.loading = true;

        const resultParent = await API.post('/execute', {
          path: '/power-plant/' + _id,
          method: 'get',
        });

        this.viewData.powerPlant = resultParent.model;

        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    }

    const _idData = this.$route.params ? this.$route.params.idData : 0;

    if (_idData) {
      this.viewData.id = _idData;

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/power-plant/' + _id + '/data/' + _idData,
          method: 'get',
        });

        this.state = { ...result.model };
        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    }
  },
  methods: {
    isNumber($event) {
      return helpers.isNumber($event);
    },
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isOk(property) {
      let hasError = helpers.hasError(this.viewData.errors, property);
      if (hasError) {
        return false;
      }
    },
    updateUrl(url) {
      this.state.url = url;
    },
    async save() {
      try {
        let data = _.cloneDeep(this.state);

        const result = await API.post('/execute', {
          path: this.viewData.id
            ? `/power-plant/${this.viewData.powerPlant.id}/data/${this.viewData.id}`
            : `/power-plant/${this.viewData.powerPlant.id}/data`,
          method: this.viewData.id ? 'put' : 'post',
          data: data,
        });

        this.$toast.success('Detalhe incluído com sucesso');

        this.$router.push(`/power-plant/${this.viewData.powerPlant.id}/data`);
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }
    },
  },
  components: {},
};
</script>
